import UserOptionsContainer from "components/containers/UserOptionsContainer/UserOptionsContainer";
import React from "react";

function UserOptionsRoute(){
  return(
      <UserOptionsContainer/>
  )
}

export default UserOptionsRoute;
